import React from 'react';
import { Info } from '@phosphor-icons/react';

export const InboxHowItWorks = ({ inboundDomain }) => (
  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex items-start gap-3" data-testid="inbox-how-it-works">
    <Info size={20} className="text-blue-700 shrink-0 mt-0.5" />
    <div className="text-sm font-ibm text-blue-900">
      <p className="font-semibold mb-1">How email-to-case works</p>
      <ol className="list-decimal pl-5 space-y-0.5 text-[13px]">
        <li>Open any case and copy its forwarding address (looks like <span className="font-mono">case-XXXXXXXX@{inboundDomain || 'inbound.harmonizer.online'}</span>).</li>
        <li>Forward or send emails to that address — the body becomes a <span className="font-mono">.eml</span> document and any attachments are added separately. AI analysis runs automatically.</li>
        <li>Emails sent to an unknown address (but from your account email) land here for you to assign to the right case.</li>
        <li><span className="font-semibold">Security:</span> only emails from accounts registered on ClarityCase AI are accepted.</li>
      </ol>
    </div>
  </div>
);
